// extracted by mini-css-extract-plugin
export default {"screen":"Screen_screen__cNp+n","negative":"Screen_negative__2J7-B","memory":"Screen_memory__0YXtR","error":"Screen_error__SwYo0"};